/** @module Specification/SizeMapRenderer */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"csi/action",
	"csi/def/Action",
	"csi/heading/Boolean",
	"csi/html",
	"csi/widget/RadioButton",
	"csi/xml"
], function(declare, lang, domClass, csiAction, Action, Boolean, html, RadioButton, xml) {

	return declare(Boolean, {
		/**
		 * @override
		 * Renders radio button array for mapping sizes >
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			const sm = ctx.getParent();
			const bEdit = xml.nodeHasAccess(sm, xml.RIGHT_WRITE) && !sm.Active;
			const urlRow = ctx.getParam(ctx.PARAM_ROW_URL);
			const urlColumn = ctx.getParam(ctx.PARAM_COLUMN_URL);
			const columnNumber = ctx.cache.getNode(sm.TargetSizeRange).Sizes.indexOf(urlColumn);
			const radioName = h.m_nameOrig;

			if (columnNumber % 2) {
				domClass.add(refNode, "csi-table-odd-background");
			}

			// figure out which SizeMapSize is our row
			const sizeMapSize = ctx.cache.getNodes(sm.SizeMapSizes).find((sms) => sms.SourceSize == urlRow);

			const bSelected = sizeMapSize ? sizeMapSize.TargetSizes.includes(urlColumn) : false;

			const radio = new RadioButton({
				name: urlColumn,
				disabled: !bEdit,
				value: bSelected
			}).placeAt(refNode);


			if (bEdit) {
				radio.onClick = function() {
					csiAction.invoke(ctx.view, refNode, lang.mixin(new Action(), {
						m_id: radioName + "Edit",
						m_onAction: function(ac) {
							ac.m_writer.callMethod("Specification", "SetSizeMapSize")
								.addParameter(xml.PROP_URL, xml.ATTR_REF, sm.$URL)
								.addParameter("Source", xml.ATTR_REF, urlRow)
								.addParameter("Target", xml.ATTR_REF, urlColumn);
						}
					}));
				};
			}

			return true;
		}
	});
});
